const page    = require('../../../../../components/page/page')
const usersDt = require('./users-dt')
const usersPageHandler = require('./users-page-handler')


import usersPage       from "./users-page.html";


/****************ELEMENTS*****************/
var HTMLwasSelected  = false

//insert the page  on the body
function HTMLselect(detail){ //console.log('users init>')
	
	HTMLwasSelected = true

	//load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", usersPage)

   attachCompanyFullcont()
   
   page.hide_page_element(detail);

   usersDt.start({"dest":"users", "elem":"dt", "act":"select", "entity":"users"})

}/*init*/

// Si Company se inicializo antes que Users, mueve su fullcont al punto de montaje de esta entidad.
function attachCompanyFullcont(){
	const companyPage = document.getElementById('company-page')
	const companyFullcont = document.getElementById('company-fullcont')

	if(companyPage === null || companyFullcont === null || companyFullcont.parentElement === companyPage){
		return
	}

	companyPage.appendChild(companyFullcont)
}

/****************ELEMENTS*****************/

export function start(detail){ //console.log('users page >', detail)
  
   if(!HTMLwasSelected) {HTMLselect(detail)}
	
	obj[detail.act].start(detail)
}

const obj = {
   
   show:           { start: (detail)=>{  page.start(detail)     }},
   checkDarkTheme: { start: (detail)=>{  usersPageHandler.checkDarkTheme(detail) }},


}/**/
